import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class CampaignShippingCostProp extends Vue {
  @Prop({ required: false, default: 0 }) campaignShippingCost!: number;
}
